import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format } from "date-fns";

import { Radio, Labeled, Badge } from "@lifepay/rc-ui-toolkit";

import CardSmsControl from "../controls/CardSmsControl";

import cardtype from "./cardtype";
import styles from "./Card.m.scss";

function BankCard(props) {
  const { theme, card, selected, onChange, updateQuery } = props;
  return (
    <div
      className={classnames(theme.wrapper, selected ? theme.selected : null)}
    >
      <Radio
        id={`bank_card_${card.cardId}`}
        name="bank_card"
        value={card.cardId}
        theme={{
          wrapper: theme.radio,
          label: theme["radio-label"],
        }}
        checked={selected}
        onChange={onChange}
      >
        <div className={classnames(theme.summary)}>
          <div className={classnames(theme.info)}>
            <div className={classnames(theme.item)}>
              <div className={classnames(theme.icon, cardtype(card.pan))}>
                {cardtype(card.pan)}
              </div>
            </div>
            <div className={classnames(theme.item)}>{card.pan}</div>
            <div className={classnames(theme.item)}>{card.expirationDate}</div>
            <div className={classnames(theme.item)}>
              <Badge type={card.isValid ? "green" : "red"}>
                {card.isValid ? "Активна" : "Заблокирована"}
              </Badge>
            </div>
            <div className={classnames(theme.item)}>
              {`${card.wrongPinCount}/3`}
            </div>
            <div className={classnames(theme.item)}>
              <CardSmsControl
                cardId={card.cardId}
                smsPhone={card.smsPhone}
                smsStatus={card.smsStatus}
                updateQuery={updateQuery}
              />
            </div>
            <div className={classnames(theme.item, theme.amount)}>
              {card.amountAvailable}
            </div>
            <div className={classnames(theme.item, theme.currency)}>
              {card.currency}
            </div>
          </div>
        </div>
      </Radio>
      <div
        className={classnames(
          theme.details,
          selected ? theme.open : theme.closed
        )}
      >
        <div className={classnames(theme.data)}>
          <div className={classnames(theme.row)}>
            <Labeled label={"Номер счета"}>{card.accountNum}</Labeled>
          </div>
          <div className={classnames(theme.row)}>
            <Labeled
              type={card.isValid ? "green" : "red"}
              label={"Расшифровка статуса карты"}
            >
              {card.statusName}
            </Labeled>
            {card.blockComment ? (
              <Labeled type={"red"} label={"Комментарий к блокировке"}>
                {card.blockComment}
              </Labeled>
            ) : null}
          </div>
          <div className={classnames(theme.row)}>
            <Labeled label={"Деpжатель карты"}>
              {card.clientName || "-"}
            </Labeled>
            <Labeled label={"Наименование продукта"}>
              {card.productName || "-"}
            </Labeled>
          </div>
          <div className={classnames(theme.row)}>
            <Labeled label={"Телефон для информирования"}>
              {card.smsPhone || "-"}
            </Labeled>
          </div>
          <div className={classnames(theme.row)}>
            <Labeled label={"Дата начала действия"}>
              {card.startDate ? format(card.startDate, "DD/MM/YYYY") : "-"}
            </Labeled>
            <Labeled label={"Дата окончания действия"}>
              {card.endDate ? format(card.endDate, "DD/MM/YYYY") : "-"}
            </Labeled>
          </div>
          <div className={classnames(theme.row)}>
            <Labeled
              type={card.errorCode !== 0 ? "red" : "green"}
              label={"Код статуса карты"}
            >
              {card.errorCode}
            </Labeled>
            <Labeled label={"Id карты"}>{card.cardId || "-"}</Labeled>
            <Labeled label={"Id контракта"}>{card.contract || "-"}</Labeled>
            <Labeled label={"seqNumber"}>{card.seqNumber || "-"}</Labeled>
          </div>
        </div>
        <div className={classnames(theme.amounts)}>
          <div className={classnames(theme.item)}>
            <div className={classnames(theme.label)}>{"Захолдировано"}</div>
            <div className={classnames(theme.value)}>
              {`${card.amountHold}`}
            </div>
          </div>
          <div className={classnames(theme.item)}>
            <div className={classnames(theme.label)}>{"Кредитный лимит"}</div>
            <div className={classnames(theme.value)}>
              {`${card.creditRemainder || card.creditRemainder} / ${
                card.creditLimit
              }`}
            </div>
          </div>
        </div>
        <div className={classnames(theme.currency)}>
          <div className={classnames(theme.item)}>
            <div className={classnames(theme.value)}>{`${card.currency}`}</div>
          </div>
          <div className={classnames(theme.item)}>
            <div className={classnames(theme.value)}>{`${card.currency}`}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

BankCard.displayName = "BankCard";

BankCard.propTypes = {
  theme: PropTypes.object,
  card: PropTypes.object,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  updateQuery: PropTypes.func,
};

BankCard.defaultProps = {};

export default themr("@lifepay/BankCard", styles)(BankCard);



// WEBPACK FOOTER //
// ./src/components/emission/cards/Card/Card.js